import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { useTheme } from '@mui/material/styles';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import { Button } from '../Button';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function PopoverFooter(props) {
  var _props$divider = props.divider,
    divider = _props$divider === void 0 ? false : _props$divider,
    primaryButtonProps = props.primaryButtonProps,
    secondaryButtonProps = props.secondaryButtonProps,
    tertiaryButtonProps = props.tertiaryButtonProps,
    _props$type = props.type,
    type = _props$type === void 0 ? 'horizontal-right-aligned' : _props$type;
  var theme = useTheme();
  return type === 'hidden' ? null : /*#__PURE__*/_jsxs(Stack, {
    role: "popover-footer",
    spacing: 4,
    children: [divider && /*#__PURE__*/_jsx(Divider, {
      color: theme.palette.gray[200],
      sx: {
        backgroundColor: 'unset',
        height: '1px'
      }
    }), /*#__PURE__*/_jsxs(Stack, {
      direction: type === 'horizontal-left-aligned' ? 'row-reverse' : 'row',
      justifyContent: "space-between",
      padding: "0px 16px 16px",
      role: "popover-footer-buttons",
      spacing: 3,
      width: "100%",
      children: [tertiaryButtonProps && /*#__PURE__*/_jsx(Stack, {
        direction: "row",
        flex: 1,
        justifyContent: type === 'horizontal-right-aligned' ? 'flex-start' : 'flex-end',
        width: "100%",
        children: /*#__PURE__*/_jsx(Button, _extends({
          size: "small",
          variant: "link-gray"
        }, tertiaryButtonProps, {
          children: tertiaryButtonProps.children
        }))
      }), /*#__PURE__*/_jsxs(Stack, {
        direction: "row",
        flex: 1,
        justifyContent: type === 'horizontal-right-aligned' ? 'flex-end' : 'flex-start',
        spacing: 2,
        width: "100%",
        children: [secondaryButtonProps && /*#__PURE__*/_jsx(Button, _extends({
          size: "small",
          variant: "link-gray"
        }, secondaryButtonProps, {
          children: secondaryButtonProps.children
        })), primaryButtonProps && /*#__PURE__*/_jsx(Button, _extends({
          fullWidth: secondaryButtonProps === undefined,
          size: "small",
          variant: "link"
        }, primaryButtonProps, {
          children: primaryButtonProps.children
        }))]
      })]
    })]
  });
}